import { ReactNode } from 'react'

export const MAX_SCROLLBAR_SIZE = 99

export type ScrollerProps = {
    children: ReactNode
    className?: string
    forceButtons?: boolean
}
